export default (function (_a) {
    var _b = _a === void 0 ? [[], ''] : _a, _c = _b[0], data = _c === void 0 ? [] : _c, _d = _b[1], glue = _d === void 0 ? '' : _d;
    return data.join(glue.toString());
});
//# sourceMappingURL=rave-join.js.map